import React, {
    useState,
    useEffect,
    useCallback,
    useMemo,
    useRef,
} from "react";
import locale from "../../../_util/locale";
import searchIcon from "../assets/imgs/searchIcon.png";
import clearIcon from "../assets/imgs/clearIcon.png";

export interface ISearchHeaderProps {
    searchPlaceholder?: string;
    searchKey?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    clearKeyword?: () => void;
    isShowCancelBtn?: boolean;
    setSearchKey: (key: string) => void;
    isSearchMode: boolean;
    handleClose: () => void;
}

const SearchHeader: React.FC<ISearchHeaderProps> = ({
    searchPlaceholder,
    searchKey = "",
    onChange,
    clearKeyword = () => {},
    setSearchKey,
    isSearchMode,
    handleClose,
}) => {
    const [inputIsFocused, setInputIsFocused] = useState(false); // 输入框是否聚焦
    const inputRef = useRef<HTMLInputElement>(null);

    // 组件挂载后自动聚焦
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <div className="searchHeader">
            <div
                className={`searchInputBox ${
                    inputIsFocused ? "isFocused" : ""
                }`}
            >
                <img className="searchIcon" src={searchIcon} />
                <input
                    ref={inputRef}
                    id="js_search-input"
                    type="text"
                    autoFocus
                    className="searchInput"
                    placeholder={searchPlaceholder}
                    value={searchKey}
                    onChange={onChange}
                    onBlur={() => setInputIsFocused(false)}
                    onFocus={() => setInputIsFocused(true)}
                />
                {searchKey && (
                    <img
                        className="searchClear"
                        src={clearIcon}
                        onClick={() => {
                            clearKeyword();
                            inputRef.current?.focus();
                        }}
                    />
                )}
            </div>
            {isSearchMode && (
                <div
                    className="cancelBtn"
                    onClick={() => {
                        handleClose();
                        inputRef.current?.focus();
                    }}
                >
                    {locale("cancel")}
                </div>
            )}
        </div>
    );
};

export default SearchHeader;
